// https://github.com/enyo/dropzone/issues/1640

/* eslint-disable */
export default function polyFileList() {
  if (!FileList.prototype.map) {
    FileList.prototype.map = function(callback) {
      let T, A, k;

      if (this == null) {
        throw new TypeError('this is null or not defined');
      }

      let O = Object(this);
      let len = O.length >>> 0;

      if (typeof callback !== 'function') {
        throw new TypeError(callback + ' is not a function');
      }

      if (arguments.length > 1) {
        T = arguments[1];
      }

      A = new Array(len);

      k = 0;

      while (k < len) {

        let kValue, mappedValue;
        if (k in O) {
          kValue = O[k];
          mappedValue = callback.call(T, kValue, k, O);
          A[k] = mappedValue;
        }
        k++;
      }
      return A;
    };
  }
}



// WEBPACK FOOTER //
// ./src/utils/pollyfillFileList.js